// app/javascript/controllers/accordion_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  static values = { open: Boolean }

  connect() {
    if (this.openValue) this.toggle()
  }

  toggle() {
    const icon = this.hasIconTarget ? this.iconTarget : null //三角形アイコンある場合
    this.contentTarget.classList.toggle("max-h-0")
    this.contentTarget.classList.toggle("max-h-auto")
    this.contentTarget.classList.toggle("opacity-0")
    this.contentTarget.classList.toggle("opacity-100")
    if (icon) icon.classList.toggle("rotate-180")
  }
}
